// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const QuickLinks = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
      <path
        d="M19.5856 7.54966L16.8745 9.89729C16.8745 9.89729 17.5309 8.94044 17.1897 7.63126C17.1563 7.51258 17.1489 7.38648 17.1155 7.26409L18.0131 6.51122L19.2444 2.66155L15.2538 3.3217L12.9284 5.33555C12.6169 5.60629 12.4017 5.94749 12.2905 6.31466C12.0865 6.98594 12.2237 7.74252 12.7133 8.30996C13.2028 8.87739 13.7814 8.9664 14.4749 8.86256C14.3637 9.22972 14.1486 9.57092 13.8407 9.84166L13.0396 10.5352C12.3461 10.3312 11.8529 10.0827 11.3448 9.49675C10.9257 9.01091 10.6475 8.45089 10.5029 7.86491C10.4732 7.74252 10.451 7.62013 10.4324 7.49774C10.3211 6.73745 10.4324 5.95491 10.7625 5.25396C10.8329 5.10561 10.9108 4.96097 10.9998 4.82745C11.1964 4.51221 11.4449 4.22293 11.7416 3.96703L14.4527 1.61939L19.0293 0.859104C19.6412 0.75526 20.2457 0.977784 20.65 1.44509C21.0542 1.91239 21.184 2.54658 20.9949 3.13627L19.5819 7.55337L19.5856 7.54966Z"
        fill="#424242"
      />
      <path
        d="M15.4418 11.4039L11.4846 14.8307C10.6427 15.5577 9.36686 15.4686 8.63624 14.6268L6.14768 11.7488C5.42077 10.9069 5.50978 9.62738 6.35166 8.90047L10.3089 5.4736C10.3089 5.4736 9.64502 6.2376 9.96026 7.77672C9.98622 7.89911 10.0011 8.02521 10.0307 8.14389L7.53846 10.269C7.45316 10.3432 7.44574 10.473 7.51992 10.5583L10.0085 13.4363C10.0827 13.5216 10.2125 13.5327 10.2978 13.4585L14.255 10.0316C14.5665 9.76461 14.7816 9.41969 14.8892 9.05253C15.0932 8.38125 14.9596 7.62467 14.4701 7.05723C13.9805 6.48979 13.4687 6.32661 12.7752 6.43045C12.8865 6.06329 13.1016 5.72208 13.4131 5.45135L14.2142 4.75781C14.9114 4.96179 15.3342 5.28445 15.8423 5.87043C16.2614 6.35628 16.5433 6.9163 16.6805 7.50228C16.7139 7.62096 16.7361 7.74334 16.7547 7.86944C16.8659 8.63344 16.7547 9.41599 16.4209 10.1169C16.3541 10.2616 16.2725 10.4062 16.1835 10.5434C15.987 10.8587 15.7385 11.148 15.4455 11.4002L15.4418 11.4039Z"
        fill="#424242"
      />
      <path
        d="M1.81726 15.1425C1.54652 15.1425 1.27949 15.0201 1.10148 14.7901C0.797359 14.397 0.871533 13.8296 1.26466 13.5255L3.07081 12.1347C3.46394 11.8306 4.03138 11.9047 4.33549 12.2979C4.63961 12.691 4.56543 13.2584 4.17231 13.5625L2.36615 14.9533C2.20297 15.0794 2.01012 15.1425 1.81726 15.1425Z"
        fill="#424242"
      />
      <path
        d="M2.16744 18.301C1.8967 18.301 1.62968 18.1786 1.45166 17.9486C1.14754 17.5518 1.22542 16.9881 1.61855 16.6839L4.06631 14.811C4.46315 14.5069 5.02688 14.5848 5.331 14.9779C5.63511 15.3748 5.55723 15.9385 5.1641 16.2426L2.71633 18.1155C2.55315 18.2416 2.3603 18.301 2.16744 18.301Z"
        fill="#424242"
      />
      <path
        d="M5.63553 19.1875C5.37221 19.1875 5.10888 19.0725 4.93086 18.8463C4.61933 18.4569 4.68609 17.8894 5.07551 17.5816L7.23028 15.8645C7.6197 15.5529 8.18714 15.6197 8.49496 16.0091C8.80649 16.3985 8.73974 16.966 8.35032 17.2738L6.19555 18.9909C6.02865 19.1244 5.83209 19.1875 5.63553 19.1875Z"
        fill="#424242"
      />
    </svg>
  );
};

export const QuickLinksGold = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
      <g id="Group 1010105153">
        <path
          id="Vector"
          d="M19.5856 7.54966L16.8745 9.89729C16.8745 9.89729 17.5309 8.94044 17.1897 7.63126C17.1563 7.51258 17.1489 7.38648 17.1155 7.26409L18.0131 6.51122L19.2444 2.66155L15.2538 3.3217L12.9284 5.33555C12.6169 5.60629 12.4017 5.94749 12.2905 6.31466C12.0865 6.98594 12.2237 7.74252 12.7133 8.30996C13.2028 8.87739 13.7814 8.9664 14.4749 8.86256C14.3637 9.22972 14.1486 9.57092 13.8407 9.84166L13.0396 10.5352C12.3461 10.3312 11.8529 10.0827 11.3448 9.49675C10.9257 9.01091 10.6475 8.45089 10.5029 7.86491C10.4732 7.74252 10.451 7.62013 10.4324 7.49774C10.3211 6.73745 10.4324 5.95491 10.7625 5.25396C10.8329 5.10561 10.9108 4.96097 10.9998 4.82745C11.1964 4.51221 11.4449 4.22293 11.7416 3.96703L14.4527 1.61939L19.0293 0.859104C19.6412 0.75526 20.2457 0.977784 20.65 1.44509C21.0542 1.91239 21.184 2.54658 20.9949 3.13627L19.5819 7.55337L19.5856 7.54966Z"
          fill="url(#paint0_linear_8344_192738)"
        />
        <path
          id="Vector_2"
          d="M15.4418 11.4039L11.4846 14.8307C10.6427 15.5577 9.36686 15.4686 8.63624 14.6268L6.14768 11.7488C5.42077 10.9069 5.50978 9.62738 6.35166 8.90047L10.3089 5.4736C10.3089 5.4736 9.64502 6.2376 9.96026 7.77672C9.98622 7.89911 10.0011 8.02521 10.0307 8.14389L7.53846 10.269C7.45316 10.3432 7.44574 10.473 7.51992 10.5583L10.0085 13.4363C10.0827 13.5216 10.2125 13.5327 10.2978 13.4585L14.255 10.0316C14.5665 9.76461 14.7816 9.41969 14.8892 9.05253C15.0932 8.38125 14.9596 7.62467 14.4701 7.05723C13.9805 6.48979 13.4687 6.32661 12.7752 6.43045C12.8865 6.06329 13.1016 5.72208 13.4131 5.45135L14.2142 4.75781C14.9114 4.96179 15.3342 5.28445 15.8423 5.87043C16.2614 6.35628 16.5433 6.9163 16.6805 7.50228C16.7139 7.62096 16.7361 7.74334 16.7547 7.86944C16.8659 8.63344 16.7547 9.41599 16.4209 10.1169C16.3541 10.2616 16.2725 10.4062 16.1835 10.5434C15.987 10.8587 15.7385 11.148 15.4455 11.4002L15.4418 11.4039Z"
          fill="url(#paint1_linear_8344_192738)"
        />
        <path
          id="Vector_3"
          d="M1.81726 15.1425C1.54652 15.1425 1.27949 15.0201 1.10148 14.7901C0.797359 14.397 0.871533 13.8296 1.26466 13.5255L3.07081 12.1347C3.46394 11.8306 4.03138 11.9047 4.33549 12.2979C4.63961 12.691 4.56543 13.2584 4.17231 13.5625L2.36615 14.9533C2.20297 15.0794 2.01012 15.1425 1.81726 15.1425Z"
          fill="url(#paint2_linear_8344_192738)"
        />
        <path
          id="Vector_4"
          d="M2.16744 18.301C1.8967 18.301 1.62968 18.1786 1.45166 17.9486C1.14754 17.5518 1.22542 16.9881 1.61855 16.6839L4.06631 14.811C4.46315 14.5069 5.02688 14.5848 5.331 14.9779C5.63511 15.3748 5.55723 15.9385 5.1641 16.2426L2.71633 18.1155C2.55315 18.2416 2.3603 18.301 2.16744 18.301Z"
          fill="url(#paint3_linear_8344_192738)"
        />
        <path
          id="Vector_5"
          d="M5.63553 19.1875C5.37221 19.1875 5.10888 19.0725 4.93086 18.8463C4.61933 18.4569 4.68609 17.8894 5.07551 17.5816L7.23028 15.8645C7.6197 15.5529 8.18714 15.6197 8.49496 16.0091C8.80649 16.3985 8.73974 16.966 8.35032 17.2738L6.19555 18.9909C6.02865 19.1244 5.83209 19.1875 5.63553 19.1875Z"
          fill="url(#paint4_linear_8344_192738)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_8344_192738"
          x1="15.7354"
          y1="0.833984"
          x2="15.7354"
          y2="10.5352"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#FFBE66" />
          <stop offset="0.335" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8344_192738"
          x1="11.2263"
          y1="4.75781"
          x2="11.2263"
          y2="15.3222"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#FFBE66" />
          <stop offset="0.335" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8344_192738"
          x1="2.71848"
          y1="11.9473"
          x2="2.71848"
          y2="15.1425"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#FFBE66" />
          <stop offset="0.335" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_8344_192738"
          x1="3.39133"
          y1="14.625"
          x2="3.39133"
          y2="18.301"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#FFBE66" />
          <stop offset="0.335" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_8344_192738"
          x1="6.71291"
          y1="15.668"
          x2="6.71291"
          y2="19.1875"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#FFBE66" />
          <stop offset="0.335" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
